import styled from 'styled-components';

export const FooterContainer = styled.div`
  position:absolute;
  bottom:0;
  left:0;
  right:0;
  box-sizing: border-box;
  //background-color:#0D1016;
  //background-color: #111111;
  background-color: #1A1A1B;
  padding:0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height:130px;
  z-index: 99;
  padding-top: 20px;
  
  @media screen and (max-width: 1000px) {
    width: 100%;
    justify-content: space-between;
    padding: 1rem 0 1rem 0;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 1000px;
  margin: auto;
  height: 50px;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    margin: 0px auto 0 auto;
  }
`;

export const TermsWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: auto;
  height: 30px;
  gap:20px;
  @media screen and (max-width: 1000px) {
    
    margin: 0px auto 0 auto;
  }
`;

export const WebsiteRights = styled.small`
  color: #ffffff99;
  margin-bottom: 10px;
  font-size: 12px;
  letter-spacing: .5px;
  width: 80%;
  font-weight: 400;
  text-align: center;
`;

export const SignOutButton = styled.a`
  color: #FFFFFF;
  margin-bottom: 20px;
  margin-top: 5px;
  font-size: 1rem;
  width: 80%;
  text-align: center;
  text-decoration: underline;  

  &:hover{
    cursor: pointer;
  }
`;

export const TermsAndServices = styled.a`
  color: #FFFFFF75;
  font-size: 12px;
  width: fit-content;
  text-align: center;  
  :hover{
    cursor:pointer;
    color: #FFFFFF;    
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
`;

export const LogoDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 150px;
  height: 40px;
`;

export const Divider = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  width: 80%;
  border-bottom: 1px solid #C5C5C5;
  height: 1px;

`;

export const SocialIconLink = styled.a`
  color: #FFFFFF;
  font-size: 25px;
  padding-left: 4px;
  padding-right: 4px;

  &:hover{
    color:#17cba4;
  }
`;